module.exports = __webpack_public_path__ + "img/gartek-services-fire-protectiin.53259f9c.jpeg";